import { render, staticRenderFns } from "./uploadAnnex.vue?vue&type=template&id=455fecf6"
import script from "./uploadAnnex.vue?vue&type=script&lang=js"
export * from "./uploadAnnex.vue?vue&type=script&lang=js"
import style0 from "./uploadAnnex.vue?vue&type=style&index=0&id=455fecf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports